import WhatsAppSipExtensionsAPI from 'dashboard/api/whatsappSip/extensions';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getById: $state => id => $state.records.find(r => r.id === id),
};

export const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await WhatsAppSipExtensionsAPI.get();
      const extensions = data.extensions || [];
      commit('SET_RECORDS', extensions);
      return extensions;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async show(_, id) {
    const { data } = await WhatsAppSipExtensionsAPI.show(id);
    return data.extension || data;
  },

  async create({ commit }, extensionData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await WhatsAppSipExtensionsAPI.create(extensionData);
      const extension = data.extension;
      commit('ADD_RECORD', extension);
      return extension;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, data: updateData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await WhatsAppSipExtensionsAPI.update(id, updateData);
      const extension = data.extension || data;
      commit('UPDATE_RECORD', extension);
      return extension;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit, dispatch }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await WhatsAppSipExtensionsAPI.delete(id);
      commit('DELETE_RECORD', id);
      // Re-fetch queues since the Go API removes the extension from queue members
      dispatch('whatsappSipQueues/fetch', null, { root: true });
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  // Presença SIP em tempo real (AMI ContactStatus → NATS → ActionCable
  // `whatsapp_sip.extension_presence`). Atualiza o contact_status do ramal
  // sem refetch — a aba Ramais do dialer reflete registro/queda na hora.
  updatePresence({ commit }, { pjsip_id: pjsipId, status }) {
    if (!pjsipId || !status || status === 'unknown') return;
    commit('UPDATE_PRESENCE', { pjsipId, status });
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  SET_RECORDS($state, records) {
    $state.records = records;
  },

  ADD_RECORD($state, record) {
    $state.records = [record, ...$state.records];
  },

  UPDATE_RECORD($state, record) {
    const index = $state.records.findIndex(r => r.id === record.id);
    if (index !== -1) {
      $state.records.splice(index, 1, { ...$state.records[index], ...record });
    }
  },

  DELETE_RECORD($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },

  UPDATE_PRESENCE($state, { pjsipId, status }) {
    $state.records = $state.records.map(r =>
      r.pjsip_id === pjsipId ? { ...r, contact_status: status } : r
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
